import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import Modal from "components/modal";
import { useDispatch, useSelector } from "react-redux";
import { deleteUsers } from "store/userSlice";

const DeleteUserModal = ({ userData, isOpen, onClose, refreshUserList }) => {
  const dispatch = useDispatch();
  const { deleteError, deleteLoading } = useSelector((state) => state.users);

  const handleDelete = async () => {
    try {
      await dispatch(deleteUsers(userData)).unwrap();
      refreshUserList();
      onClose();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-lg">
      <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
        Delete User
      </h2>

      <div className="relative w-full rounded-3xl p-4  lg:p-5 ">
        <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
          Are you sure you want to delete this user?
        </p>

        <div className="flex flex-col">
          {deleteError && (
            <div className="mt-2 grid grid-cols-1 gap-5 lg:grid-cols-1">
              <p className="text-sm text-red-500">{deleteError}</p>
            </div>
          )}

          <div className="mt-6 flex items-center justify-end gap-3">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>

            <LoaderButton
              type="button"
              isLoading={deleteLoading}
              onClick={handleDelete}
            >
              Delete User
            </LoaderButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteUserModal;
